module.exports = __webpack_public_path__ + "static/gold-756fb91b1076ec9f9f5f9ee188fe49a8.png";